import React from "react";

/**
 * Shared warming / progress UI for Cost Analytics + Team Usage.
 * Shown while the backend returns ``{ warming: true, progress }`` so the
 * request never H12s; the page polls until the rollup cache is ready.
 */
export default function AnalyticsWarmingBanner({
  label = "Loading analytics data…",
  progress = 0,
}) {
  const pct = Math.max(0, Math.min(100, Math.round((progress || 0) * 100)));
  return (
    <div className='bg-white rounded-2xl border border-border-subtle p-6'>
      <div className='flex flex-col items-center gap-3 py-6'>
        <div className='animate-spin rounded-full h-6 w-6 border-2 border-accent-purple border-t-transparent' />
        <p className='text-body-sm text-text-secondary'>{label}</p>
        <div className='w-full max-w-md'>
          <div className='flex items-center justify-between text-caption text-text-tertiary mb-1.5'>
            <span>Warming cache</span>
            <span>{pct}%</span>
          </div>
          <div className='h-2 rounded-full bg-surface-neutral overflow-hidden'>
            <div
              className='h-full rounded-full bg-accent-purple transition-all duration-500 ease-out'
              style={{ width: `${Math.max(pct, 4)}%` }}
            />
          </div>
        </div>
        <p className='text-caption text-text-tertiary max-w-md text-center'>
          First load after a deploy can take a moment while daily cost rollups
          fill. This page will update automatically — it will not time out.
        </p>
      </div>
    </div>
  );
}
